import React from "react";

export interface OffsetSelectorProps {
    /** Since they're 1-indexed, the size is also the maximum value. */
    familySize: number,
    onSelect: (n: number) => void,
    selected?: number,
}

export function OffsetSelector(props: OffsetSelectorProps) {
    let options: JSX.Element[] = [];
    if (props.familySize === 0) {
        return null;
    }
    if (props.selected === undefined) {
        options.push(<option key=""> </option>);
    }
    for (let n = 1; n <= props.familySize; ++n) {
        options.push(<option
            key={n}
            value={n}>
            {n}
        </option>);
    }
    return (<select
        className="selector"
        onChange={(ev) => props.onSelect(Number(ev.target.value))}
        value={props.selected}>
        {options}
    </select>);
}